<template>
  <div>
    <div class="m-b">
      <label>{{ labelText }}</label>
      <el-input
        class="m-l-sm"
        v-model="dataNumber"
        :precision="this.$globalVar.qPoint"
        disabled
        clearable
        maxlength="32"
      >
      </el-input>
    </div>
    <vxe-toolbar>
      <template v-slot:buttons>
        <vxe-button class="vxe-btn-primary" type="primary" @click="handleAdd" icon="el-icon-plus">{{
          $t('xTable.insert')
        }}</vxe-button>
        <vxe-button
          class="vxe-btn-delete"
          type="danger"
          @click="handleDelete"
          icon="el-icon-delete"
          >{{ $t('xTable.delete') }}</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      border
      resizable
      show-overflow
      :data="tableData"
      size="mini"
      ref="ruleTable"
      :edit-rules="{}"
      auto-resize
      @cell-dblclick="dblclickEvent"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left"></vxe-table-column>
      <vxe-table-column
        :title="$t('businessOrder.list.sortNo')"
        fixed="left"
        type="seq"
        width="60"
      ></vxe-table-column>
      <!-- <template v-for="(item, index) in columns"> -->
      <vxe-table-column
        v-for="(item, index) in columns"
        :key="index"
        :fixed="item.fixed"
        :field="item.prop"
        :format="item.formatter"
        :width="item.width || 100"
        :title="item.label"
      >
        <template slot-scope="scope">
          <span v-if="item.format">
            {{ scope.row[item.prop] | formatTableColumn(item.format) }}
          </span>
          <span v-else>{{ scope.row[item.prop] }}</span>
        </template>
      </vxe-table-column>
      <!-- </template> -->
    </vxe-table>
    <add-dialog
      :type="type"
      ref="addDialog"
      :checkRowKeys="checkRowKeys"
      @confirm="confirm"
      :departmentCode="departmentCode"
    ></add-dialog>
  </div>
</template>

<script>
  import addDialog from './add-dialog';
  import { handleContractEditPath } from '@/common/js/contract';
  export default {
    components: {
      addDialog,
    },
    props: {
      defaultData: {
        type: Array,
        default: () => [],
      },
      type: {
        type: String, // sales
        default: 'purchase',
      },
      // sxp 添加 TAPD ID1001044
      departmentCode: {
        type: String,
        default: '',
      },
      // =======================
    },
    watch: {
      // 将默认值给表格数据
      defaultData() {
        this.checkRowKeys = this.defaultData.map((item) => {
          return item.contractNo;
        });
        this.tableData = this.defaultData.slice();
        const dataLength = this.tableData.filter((item) => {
          return this.type === 'purchase'
            ? item.contractDetailCategory == 'HT03'
            : item.contractDetailCategory == 'HT07';
        });
        var s = 0;
        if (dataLength.length != 0) {
          dataLength.forEach((item) => {
            s += item.productQuantity;
          });
        }
        this.dataNumber = s;
      },
    },
    data() {
      return {
        tableData: [],
        checkRowKeys: [],
        dataNumber: 0,
      };
    },
    computed: {
      labelText() {
        return this.type == 'purchase'
          ? this.$t('businessOrder.add.purchaseLabel')
          : this.$t('businessOrder.add.salesLabel');
      },
      columns() {
        return [
          {
            prop: 'contractDetailNo',
            label: this.$t('businessOrder.list.contractDetailNo'),
            fixed: 'left',
          },
          { prop: 'contractNo', label: this.$t('businessOrder.list.contractNo'), fixed: 'left' }, // 合同号
          this.type === 'purchase'
            ? { prop: 'supplierName', label: this.$t('businessOrder.list.partnerNo') }
            : { prop: 'customerName', label: this.$t('businessOrder.list.customer') },
          { prop: 'tradeTypeName', label: this.$t('salePurchase.search.tradeType') },
          { prop: 'businessTypeName', label: this.$t('salePurchase.search.businessType') },
          { prop: 'externalContractNo', label: this.$t('salePurchase.search.externalContractNo') },
          {
            prop: 'contractBusinessDepartmentName',
            label: this.$t('salePurchase.search.contractBusinessDepartment'),
          },
          { prop: 'gmtCreate', label: this.$t('salePurchase.table.gmtCreate') },
          { prop: 'contractDetailCategoryName', label: this.$t('businessOrder.list.contractType') },
          { prop: 'productDesc', label: this.$t('salePurchase.search.product') },
          {
            prop: 'productQuantity',
            label: this.$t('businessOrder.list.contractNumber'),
            format: 'formatQuality',
          },
          {
            prop: 'businessContractUnitPrice',
            label: this.$t('salePurchase.table.businessContractUnitPrice'),
            format: 'formatPrice',
          },
          {
            prop: 'businessContractTotalAmount',
            label: this.$t('businessOrder.list.totalContractPriceTax'),
            width: 120,
            format: 'formatAmountRound',
          },
          {
            prop: 'businessChangeTotalAmount',
            label: this.$t('businessOrder.list.totalVariablePriceTax'),
            width: 120,
            format: 'formatAmountRound',
          },
          { prop: 'storageName', label: this.$t('salePurchase.search.warehouse') },
          { prop: 'priceIdentityName', label: this.$t('businessOrder.list.priceIdentify') },
          { prop: 'unitName', label: this.$t('salePurchase.table.unit') },
          { prop: 'settleBatchNumber', label: this.$t('salePurchase.table.settleBatchNumber') },
        ];
      },
    },
    methods: {
      handleContractEditPath,
      handleAdd() {
        this.$refs.addDialog.defaultVisible = true;
      },
      confirm(selections) {
        selections.forEach((item) => {
          const contractNo = item.contractNo;
          const contractDetailNo = item.contractDetailNo;
          const index = this.tableData.findIndex((item) => {
            return item.contractNo == contractNo && item.contractDetailNo == contractDetailNo;
          });
          if (index < 0) {
            item.gmtCreate = item.contractCreateDate;
            this.tableData.push(item);
          }
        });
        const dataLength = this.tableData.filter((item) => {
          return this.type === 'purchase'
            ? item.contractDetailCategory == 'HT03'
            : item.contractDetailCategory == 'HT07';
        });
        var s = 0;
        if (dataLength.length != 0) {
          dataLength.forEach((item) => {
            s += item.productQuantity;
          });
        }
        this.dataNumber = s;
        this.$refs.addDialog.defaultVisible = false;
      },
      // TODO sxp 添加 TAPD ID1001044
      clearData() {
        this.tableData = [];
        this.dataNumber = 0;
      },
      // ============================
      handleDelete() {
        const selectedList = this.$refs['ruleTable'].getCheckboxRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs['ruleTable'].removeSelecteds();
            this.tableData = this.$refs.ruleTable.getTableData().fullData;
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('message.success'),
            });
            this.checkRowKeys = this.getValues().map((item) => {
              return item.contractNo;
            });
            const dataLength = this.tableData.filter((item) => {
              return this.type === 'purchase'
                ? item.contractDetailCategory == 'HT03'
                : item.contractDetailCategory == 'HT07';
            });
            var s = 0;
            if (dataLength.length != 0) {
              dataLength.forEach((item) => {
                s += item.productQuantity;
              });
            }
            this.dataNumber = s;
          })
          .catch(() => {
            this.$message({ showClose: true, type: 'info', message: this.$t('message.cancle') });
          });
      },
      //双击单元格事件
      dblclickEvent(value) {
        this.handleContractEditPath(value.row.contractDetailCategory, value.row.contractNo);
      },
      getValues() {
        const allData = this.$refs['ruleTable'].getTableData();
        const type = this.type == 'purchase' ? 1 : 2;
        return allData.tableData.map((item) => {
          return {
            associationDataType: type,
            associationOrderNo: item.contractNo,
            associationOrderDetailNo: item.contractDetailNo,
          };
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  label {
    font-size: 12px;
  }
  .el-input {
    width: 200px;
  }
</style>
